import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import React from 'react'

import { DisplayAssetProps } from '../../../types/preview'
import CarouselView from './CarouselView'
import FullscreenDisplay from './FullscreenDisplay'

const UndisplayableAsset = ({
  asset,
  height,
  maxWidth,
  modalOpen,
  icon,
  errorText,
  openInModal,
}: DisplayAssetProps & {
  icon: IconDefinition
  errorText: string
}): React.ReactElement => {
  if (modalOpen) {
    return (
      <FullscreenDisplay
        asset={asset}
        openInModal={openInModal}
        height={height}
        maxWidth={maxWidth}
        icon={icon}
        modalOpen={modalOpen}
        errorText={errorText}
      />
    )
  } else {
    return (
      <CarouselView
        asset={asset}
        openInModal={openInModal}
        height={height}
        maxWidth={maxWidth}
        icon={icon}
        modalOpen={modalOpen}
      />
    )
  }
}

export default UndisplayableAsset
